export default __webpack_public_path__ + "static/media/Armbands of the Swift Talon.f3bea190.jpg";